import axios from 'axios';
import Logger from '@/Logger';
import qs from 'qs';

// Create instance of logger
const logger = new Logger('logStore', 'Actions');

export default {
  missingString({ commit }, path) {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.post('log', qs.stringify({ message: `Could not find string with path: '${path}'`, level: 'warning' }));

        // Keep track of logged missing strings on the frontend
        commit('missingString', path);

        // Resolve promise
        resolve();

      // Catch errors
      } catch (error) {
      // Log action and status.
        logger.warn('missingString', 'Response', { [error.response.status]: error.response.statusText });

        // Reject promise
        reject();
      }
    });
  },
};
